import { MisEntry } from "../../interfaces/ActionStartResponse";
import { iEnquiryDetails } from "../EmsAPI/Enquiries";
import { iEmsApiResponse } from "../EmsAPI/FetchExtension";

export interface SaveRequest {
    enquiryId: number;
    /** Present only when the general properties changed. */
    general?: iEnquiryDetails;
    /** Only the MIS entries the user changed. */
    misChanges: MisEntry[];
    updateGeneral: (details: iEnquiryDetails) => Promise<iEmsApiResponse>;
    updateMis: (enquiryId: number, misData: MisEntry[]) => Promise<iEmsApiResponse>;
}

export interface SaveOutcome {
    ok: boolean;
    generalSaved: boolean;
    failedStep?: "general" | "mis";
    failure?: iEmsApiResponse;
}

/** Saves general changes, then MIS changes. The two calls are not atomic. */
export async function saveEnquiryProperties(request: SaveRequest): Promise<SaveOutcome> {
    let generalSaved = false;

    if (request.general) {
        const response = await request.updateGeneral(request.general);
        if (!response.isOk) return { ok: false, generalSaved, failedStep: "general", failure: response };
        generalSaved = true;
    }

    if (request.misChanges.length > 0) {
        const response = await request.updateMis(request.enquiryId, request.misChanges);
        if (!response.isOk) return { ok: false, generalSaved, failedStep: "mis", failure: response };
    }

    return { ok: true, generalSaved };
}
